import React, { Children, Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import styles from './workmenu.css';

class WorkMenu extends Component {
	render() {
		const { children, index } = this.props;

		return (
			<div className={styles.content}>
		  	<CSSTransitionGroup
		      transitionName={styles}
		      transitionEnterTimeout={500}
		      transitionLeaveTimeout={200}>
					{Children.toArray(children)[index]}
		  	</CSSTransitionGroup>
			</div>
		);
	}
}

export default WorkMenu;


// WEBPACK FOOTER //
// ./src/components/WorkMenu/WorkMenu.js